export enum UserStatusEnum {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
  REGISTER_ENABLED = 'REGISTRO LIBERADO',
  REGISTER_BLOCKED = 'REGISTRO BLOQUEADO',
}

export enum ValidityStatusEnum {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
}


export enum InstitutionStatusEnum {
  REGISTER_ACTIVE = 'CADASTRO ATIVO',
  REGISTER_INACTIVE = 'CADASTRO INATIVO',
  REGISTER_BLOCKED = 'CADASTRO BLOQUEADO',
  REGISTER_ENABLED = 'CADASTRO DESBLOQUEADO',
}

export enum InstitutionContactTypeEnum {
  CELLPHONE = 'CELLPHONE',
}

export const municipios = [
  'Cuiabá',
  'Várzea Grande',
  'Rondonópolis',
  'Sinop',
  'Tangará da Serra',
  'Lucas do Rio Verde',
  'Barra do Garças',
];

export const permissoes = [
  'Administrador',
  'Representante Legal Estadual',
  'Gerente Estadual',
  'Operador Estadual',
  'Conselheiro Estadual',
];

export enum CuffaProductionTypeEnum {
  VEGETAL = 'VEGETAL',
  ANIMAL = 'ANIMAL',
}

export enum CuffaProductTypeEnum {
  PADRAO = 'PADRAO',
  CUSTOMIZADO = 'CUSTOMIZADO',
}

export enum CuffaManagementTypeEnum {
  AGROECOLOGICA = 'AGROECOLÓGICA',
  SISTEMAS_AGROFLORESTAIS_SAF = 'SISTEMAS AGROFLORESTAIS (SAF)',
  ORGANICA = 'ORGÂNICA',
  CONVENCIONAL = 'CONVENCIONAL',
}

export enum CuffaMeasurementUnitEnum {
  QUILOGRAMAS = 'QUILOGRAMAS',
  TONELADAS = 'TONELADAS',
  LITROS = 'LITROS',
  UNIDADES = 'UNIDADES',
  CABECAS = 'CABEÇAS',
  MIL_FRUTOS = 'MIL FRUTOS',
  ARROBAS = 'ARROBAS',
  MACOS = 'MAÇOS',
  FARDOS = 'FARDOS',
  CAIXAS = 'CAIXAS',
  MIL_LITROS = 'MIL LITROS',
}


export enum CuffaAgroecologicalCertificationEnum {
  CERTIFICADORA_POR_AUDITORIA = 'CERTIFICADORA POR AUDITORIA',
  ORGANISMO_PARTICIPATIVO_OPAC = 'ORGANISMO PARTICIPATIVO DE AVALIAÇÃO DA CONFORMIDADE - OPAC',
  ORGANIZACAO_CONTROLE_SOCIAL_OCS = 'ORGANIZAÇÃO DE CONTROLE SOCIAL – OCS',
  OUTRO = 'OUTRO',
}
